import { useState } from 'react';
import Button from 'src/components/buttons/button';
import BulletedList from 'src/components/bulletedList';
import config from 'config/config';
import Icon from 'src/components/icon';

const PROGRAM_URL = `${config.cdn.navigator}living-with-high-blood-pressure/`;

const getMenu = () => (
  <section className="navigator__contents">
    <div className="navigator__contents-header">Contents</div>
    <ul className="navigator__contents__list">
      <li><div className="navigator__contents__number">1.</div><div className="navigator__contents__content-text"><a href="#1">What is high blood pressure?</a></div></li>
      <li><div className="navigator__contents__number">2.</div><div className="navigator__contents__content-text"><a href="#2">What does high blood pressure do to your body?</a></div></li>
      <li><div className="navigator__contents__number">3.</div><div className="navigator__contents__content-text"><a href="#3">Our Senior Cardiac Nurse explains the risks of blood pressure</a></div></li>
      <li><div className="navigator__contents__number">4.</div><div className="navigator__contents__content-text"><a href="#4">Still have questions about blood pressure?</a></div></li>
    </ul>
  </section>
);

const getPage = () => (
  <div className="navigator">
    <section className="navigator__content">
      <h1 className="navigator__title">
        {'Week 1: Understanding blood pressure'}
      </h1>
      <p>{`If you've recently found out that you have high blood pressure and you want to learn more about it, you're in the right place.`}</p>
      <div className="visible-xs">{getMenu()}</div>
      <h2>What is high blood pressure?</h2>
      <p>
        High blood pressure (sometimes called hypertension) means that your heart has to work harder to pump blood around your body,
        so the pressure in your arteries is always higher than it should be.
      </p>
      <p>
        High blood pressure might not come with symptoms,
        but you should take it seriously because it puts you at a higher risk of heart attacks, heart failure and strokes.
      </p>
      <p>But by making a few simple changes, you have the power to improve your health and bring your blood pressure to a healthier level.</p>
      <a href="https://www.bhf.org.uk/heart-health/risk-factors/high-blood-pressure" rel="noreferrer" target="_blank">
        <Button
          icon="open-right"
          iconLeftAligned={false}
          text={'Find out more about high blood pressure'}
        />
      </a>

      <h2>What high blood pressure means for your health</h2>
      <div className="navigator__video-container">
        <iframe
          allow="autoplay; encrypted-media; fullscreen"
          src="https://www.youtube.com/embed/y6QJceOAVY0"
        />
      </div>

      <h2>Expert advice from a Senior Cardiac Nurse</h2>
      <p>
        Our Senior Cardiac Nurse Julie Ward shares some things that she wants you to know about high blood pressure
        - including how you can help to lower it.
      </p>
      <p>You can help to lower your blood pressure if you:</p>
      <BulletedList items={[
        'Stay a healthy weight',
        'Exercise regularly',
        'Cut down on how much salt you eat',
        'Cut down on how much alcohol you drink']
      }
      />
      <a href="https://www.bhf.org.uk/heart-matters-magazine/medical/6-things-you-need-to-know-about-high-blood-pressure" rel="noreferrer" target="_blank">
        <Button
          icon="open-right"
          iconLeftAligned={false}
          text={'Read more advice from Julie Ward'}
        />
      </a>

      <h2>Heart Helpline</h2>
      <p>Specially trained cardiac nurses will be happy to answer your questions, listen to your concerns and offer the information and support you need.</p>
      <p>Monday-Friday, 9am-5pm.</p>
      <p>Call 0300 330 3311</p>
      <a aria-label="Email a cardiac nurse" href="mailto:hearthelpline@bhf.org.uk">
        <Button
          icon="open-right"
          iconLeftAligned={false}
          text={'Email a cardiac nurse'}
        />
      </a>

      <img alt="Content provided by BHF" className="navigator__image-full navigator__banner-footer" src={`${PROGRAM_URL}bhf-content.jpg`} />
    </section>
  </div>
);

function Footer() {
  const [visible, setVisible] = useState(true);

  if (!visible) return null;
  return (
    <div className="navigator__footer">
      <img className="navigator__footer__image" src={`${PROGRAM_URL}cta-heartmatters.png`} />
      <div className="navigator__footer__inner">
        <div className="navigator__footer__title">
          Heart Matters can keep your heart healthy...
        </div>
        <div className="navigator__footer__description">
          Heart Matters offers FREE information and support to help you look after your heart.
          {' '}
          <a
            className="navigator__footer__link"
            href="https://www.bhf.org.uk/heart-health/how-we-can-help/heart-matters"
            rel="noreferrer"
            target="_blank"
          >
            Subscribe for free here {'>'}
          </a>
        </div>
        <div className="navigator__footer__close" onClick={() => setVisible(false)}>
          <Icon icon="cross" />
        </div>
      </div>
    </div>
  );
}

const obj = {
  getPage,
  getMenu,
  Footer,
  getSeoTitle: 'Living with high blood pressure | HealthUnlocked',
};

export default obj;
